import * as actions from "../actions";

const initialState = {
  notARobot: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_NOT_A_ROBOT:
      return {
        notARobot: action.payload.notARobot
      }
    default:
      return state
  }
}
